module.exports = __webpack_public_path__ + "media/images/type-2-85a388596f754adeb53e1bc56aff22d4.png";